import React from 'react';

const SvgDiamondActive = ({ cx, cy, color, mouseEnter, mouseLeave, index }) => (
  <svg
    cx={cx}
    cy={cy}
    x={cx - 8}
    y={cy - 10}
    fill={color}
    width={16}
    height={16}
    onMouseEnter={() => mouseEnter(cx, cy, index)}
    onMouseLeave={() => mouseLeave()}
  >
    <defs>
      <filter
        id="diamondActive_svg__a"
        width="250%"
        height="250%"
        x="-75%"
        y="-75%"
        filterUnits="objectBoundingBox"
      >
        <feOffset in="SourceAlpha" result="shadowOffsetOuter1" />
        <feGaussianBlur
          in="shadowOffsetOuter1"
          result="shadowBlurOuter1"
          stdDeviation={2}
        />
        <feComposite
          in="shadowBlurOuter1"
          in2="SourceAlpha"
          operator="out"
          result="shadowBlurOuter1"
        />
        <feColorMatrix
          in="shadowBlurOuter1"
          values="0 0 0 0 0.82745098 0 0 0 0 0.337254902 0 0 0 0 0.211764706 0 0 0 0.5 0"
        />
      </filter>
      <path id="diamondActive_svg__b" d="M261 54h8v8h-8z" />
    </defs>
    <g fill="none" transform="rotate(45 196.148 -275.52)">
      <use
        fill="#000"
        filter="url(#diamondActive_svg__a)"
        xlinkHref="#diamondActive_svg__b"
      />
      <path
        fill="#FFF"
        fillRule="evenodd"
        stroke={color}
        strokeLinejoin="square"
        strokeWidth={2}
        d="M262 55h6v6h-6z"
      />
    </g>
  </svg>
);

export default SvgDiamondActive;
